"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectHashMap = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
/** A utility class to hold hashes for change comparison */
class ObjectHashMap {
    constructor() {
        this.map = {};
        /** get a stored hash, returns undefined if not previously calculated */
        this.getHash = (item) => {
            const { pk, sk } = item;
            return this.map[pk]?.[sk];
        };
        this.add = (item) => {
            const { pk, sk } = item;
            const hash = (0, iotv_v3_types_1.getObjectHash)(item);
            if (!this.map[pk])
                this.map[pk] = {};
            this.map[pk][sk] = hash;
        };
        this.remove = (item) => {
            const { pk, sk } = item;
            if (!this.isKnown)
                return false;
            delete this.map[pk][sk];
        };
        this.isKnown = (item) => {
            const { pk, sk } = item;
            return !!this.map[pk]?.[sk];
        };
        this.isNew = (item) => !this.isKnown(item);
        this.isSame = (item) => {
            const currentHash = (0, iotv_v3_types_1.getObjectHash)(item);
            return this.isKnown(item) && currentHash === this.getHash(item);
        };
        this.hasChanged = (item) => {
            return this.isKnown(item) && !this.isSame(item);
        };
        this.containedDatastoreObjectKeys = () => Object.entries(this.map).reduce((a, [pk, skMap]) => {
            a.push(...Object.keys(skMap).map((sk) => {
                return { pk, sk };
            }));
            return a;
        }, []);
        /** return list of keys that have been hashed but are not present in provided items list  */
        this.getHashedItemsNotPresent = (items) => this.containedDatastoreObjectKeys().filter((dok) => !items.find(({ sk, pk }) => (0, iotv_v3_types_1.objectsMatch)(dok, { sk, pk })));
        this.getChangeState = (items) => {
            const deleted = this.getHashedItemsNotPresent(items);
            const changeContext = { new: [], changed: [], deleted, same: [] };
            return items.reduce((a, c) => {
                const isNew = this.isNew(c);
                const isChanged = this.hasChanged(c);
                const isSame = this.isSame(c);
                let checksum = [isNew, isChanged, isSame].reduce((a, c) => {
                    if (c) {
                        a++;
                    }
                    return a;
                }, 0);
                if (deleted.find((item) => item.sk === c.sk && item.pk === c.pk)) {
                    checksum++;
                }
                if (checksum > 1) {
                    throw new Error(`Err: getChangeState, more than one change state for an item ${c.sk}`);
                }
                if (checksum == 0) {
                    throw new Error(`Err: getChangeState, has not categorised item ${c.sk}`);
                }
                if (isNew) {
                    a.new.push(c);
                }
                if (isChanged) {
                    a.changed.push(c);
                }
                if (isSame) {
                    a.same.push(c);
                }
                return a;
            }, changeContext);
        };
    }
}
exports.ObjectHashMap = ObjectHashMap;
